const DOC_FILE_ICON_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE8UlEQVR4nO2cCU/jMBCF/TN3/+YKAQIhrq5QKFe4ytEQ6E3vWgghcWT1IhyVLk3sHOu1O096gibTA3+ZGdttYYxEIpFIJBKJRCKRSCQSiUQikUgkM9Vut4PHx8cv7nQ6kXFeuNVqRW42m5EbjUbker0euVarRX54ePji+/v70IhrNpsfjUbj1fd9z/f9n2yRhAHnnEeeTCaRx+Nx5NFo9MXD4TDyYDCI3O/3I/d6vcjdbjfyPOAACzhXV1e/2KIoDYChxODLAhCDL7IJEJAx5+fnv9kiqCgAPYWrH+VNlCnECAiu69oPQSeAztTVj35QrVbDx5yGcHBwYDcEDIBuAPV6PfB9H7U/fN5ZCI7jOMxW6QbQ/iw/nucFFxcXwdPT07cQSqWSnRAwADoBtD5nPre3t2i8wfPz81wIm5ub9kHQBaAzU/9vbm6Cs7Oz4OXlJRbC+vq6XRDyAtDP2IAB4PT0NHh9fU2EsLKyYg8E/FF5Z0AvA4C3tzcpCEtLS3ZAKAJAP2UPQAl6f3+XhrC8vGw+hP8BQK1WC9cAaMIAoAJhdXV1n5ks3QDa7Xa4Dri7uwsuLy+Dj48PZQgbGxvmQtANoNPphLuoWIhdX1+HANJA2NnZMRMCmqBuAK3PPoAyBKWFsLe3Zx6Efw2gm7AdIZQWguM4S8wkIf3zAjDImAUYwGmlgYBM2t/f/8FsAzAueEta9AKxK4qG7LoudkNRWoLd3V1sRWAljJkPFmOYhoY/19bW0APCeECsVCr3zFQARZWhnkQWYEY0DaFSqYSLs6OjI1zVIYhSqRQO9tbWVujt7e3wNo7j/OHhIe77wkwRam+eAAYZe8E0BOyQYosa6wNc3QCBjAAMx3Ei4zaO4zzijo+P35ntAEY5Z8F3EFDP0ZixSgYIbFdjtYxBPjk5CY3fYRzHecQhC5gtAIp8b7gbA0HsE+H1CRAoS9gzwnoBAy2M24CEjEEcYDCTAaQpQ8OUWZAEAdkgQIj3jVGeMNDCuI3jOI849A5mK4BxDr1ABsIsiGkYs59FEsdwHnHICGaKcNUkAcgjC/opIXwHIslWAMijGQ9yhCADQ8RYCWCSMguSStF3EGRAxNkoAGhe8wCkzYKhYimaByEtCGsBTHIsRaogZICIGKMAYAoXB2AWQrVa/WslWqTxXBjQJDDTthpAuVz+Z4MvjOdcaADTEKqaMkCmRIkYKwFwhcWZzMxoXl+Y1xtUvBAAJgVDyALCWgC8IAhJIGShiBhs2DFThM0sFQA8oRTJQMgDRJyNyoCsACYZIMSByALDKAD4QJQqAJ4Sgmo2qEIRMVYD8Dwv0zQU98WbJ2kyQtZWAyjnsBDDY8SVpawwjAKAK1pHBowk+oMqFBFjNQAu2RNU+kIaEHFeSABcAUISiKwwFhYALwCEChQRZ9RCrAgAXBFCGhhxNgoAdjeLAMDnQJABkRWGUSWoSAA8AYQsDBUoiLM6A7yM09C46SleiwqQeTYKAObkKgDKBb4jhsdOkxmzNqoEqQLwCs6ArOUKcUZlAF5s0T2AZ+wTqjYqA/4XADxHGASA6wODOCpBXK8JACcA0kK91D1gPGcb1QMIgGYRAM3Cl9x0DxjP2fibmCkiAJqFbxTqHjCes436liQB0CwCoFkEQLPwfxbwgm2y67rmACCRSCQSiUQikUgkEolEIpFIJBKJfdEfzZvjMoZWWZ0AAAAASUVORK5CYII=";

export function DocFileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M0 0H32V32H0V0Z" fill="url(#pattern0_4457_4659)" />
      <defs>
        <pattern id="pattern0_4457_4659" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_4457_4659" transform="scale(0.0104167)" />
        </pattern>
        <image
          id="image0_4457_4659"
          width="96"
          height="96"
          preserveAspectRatio="none"
          xlinkHref={DOC_FILE_ICON_BASE64}
        />
      </defs>
    </svg>
  );
}
